import api from './apiClient';

export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getUsers: (params = {}) => api.get('/admin/users', { params }),
  getEvents: (params = {}) => api.get('/admin/events', { params }),
  getOrders: (params = {}) => api.get('/admin/orders', { params }),
  getPlannerOrders: (params = {}) => api.get('/planner/orders', { params }),
  getAnalytics: (dateRange) => api.get('/admin/analytics', { params: dateRange }),
  clearCache: () => api.delete('/admin/cache'),
};

export default adminAPI;

